import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { Observable } from 'rxjs'

import { EventWithVenue } from "../../../models";
import { Component, OnInit } from '@angular/core';
import { StringDatePipe } from '../../../ui-helper/string-date.pipe';
import { SortService, FilterListService } from "../../../services";
import { ActivatedRoute, Router } from '@angular/router';

let moment: any = require("moment")

@Component({
	selector: 'event-list',
	templateUrl: "./event-list.html",
	styles: [require('./event-list.scss') ],
})

export class EventListComponent implements OnInit {
	events$: Observable<EventWithVenue[]>;
	displayEvents$: Observable<EventWithVenue[]>
	searchFrom: string = "";
	searchTo: string = "";
	searchTitle: string = "";
	searchVenue: string = "";
	orderByProperty: string = "begin";
	showPastEvents: boolean = false;
	disableCheckbox: boolean = false;

	private currentPage: number
	private BACKEND_DATE_FORMAT: string = "YYYY-MM-DDTHH:mm:00";

	constructor(
		private sortService: SortService,
		private filterListService: FilterListService,
		private store: Store<AppState>,
		private route: ActivatedRoute,
		private router: Router
	) { }

	ngOnInit() {
		this.events$ = this.store.select("eventServerState", "eventOverview", "eventsWithVenues")

		this.route.params.subscribe(params => {
			if (Object.keys(params).length > 0) {
				this.searchTitle = params["title"]
				this.searchVenue = params["venue"]
				this.searchFrom = params["from"]
				this.searchTo = params["to"]
				this.showPastEvents = params["showPastEvents"] === "true"
				this.orderByProperty = params["sort"]
				this.currentPage = parseInt(params["page"])

				this.displayEvents$ = this.events$
					.map(eventsWithVenues => this.getFilteredList(eventsWithVenues, this.searchTitle, this.searchVenue, this.searchFrom, this.searchTo))
					.map(eventsWithVenue => this.sortService.sort(eventsWithVenue, this.orderByProperty))
			} else {
				this.searchTitle = ""
				this.searchVenue = ""
				this.searchFrom = ""
				this.searchTo = ""
				this.showPastEvents = false
				this.orderByProperty = "begin"
				this.currentPage = 1

				this.displayEvents$ = this.events$.map(eventsWithVenue => this.filterPastEvents(eventsWithVenue))
						.map(eventsWithVenue => this.sortService.sort(eventsWithVenue, this.orderByProperty))
			}
			this.updateCheckbox()
		})
	}

	pageChanged(pageNumber: number) {
		this.currentPage = pageNumber;
	}

	navigateToDetails(id) {
		// damit auf der event detail seite der button 'zurück zur suche' korrekt funktionieren kann, muss die url mit den filter parametern
		// in der history vorhanden sein
		// daher wird erst mit filter parametern auf die events seite navigiert und dann auf die detail seite
		// (weitere info siehe commit message)
		this.router.navigate(["/events", {
			title: this.searchTitle,
			venue: this.searchVenue,
			from: this.searchFrom,
			to: this.searchTo,
			showPastEvents: this.showPastEvents,
			sort: this.orderByProperty,
			page: this.currentPage
		}]).then(() => {
			this.router.navigate([id], { relativeTo: this.route })
		})
	}

	resetSearch() {
		this.searchTitle = ""
		this.searchVenue = ""
		this.searchFrom = ""
		this.searchTo = ""
		this.showPastEvents = false
		this.orderByProperty = "begin"
		this.currentPage = 1
		this.updateCheckbox()
		this.displayEvents$ = this.events$.map(eventsWithVenue => this.filterPastEvents(eventsWithVenue))
						.map(eventsWithVenue => this.sortService.sort(eventsWithVenue, this.orderByProperty))
		this.router.navigate(["/events"])
	}

	public orderByPropertyChanged(property: string) {
		this.orderByProperty = property
		this.displayEvents$ = this.displayEvents$.map(eventsWithVenues => this.sortService.sort(eventsWithVenues, this.orderByProperty))
		this.currentPage = 1
	}

	public filterEventList() {
		this.updateCheckbox()
		this.displayEvents$ = this.events$
			.map(eventsWithVenues => this.getFilteredList(eventsWithVenues, this.searchTitle, this.searchVenue, this.searchFrom, this.searchTo))
			.map(eventsWithVenue => this.sortService.sort(eventsWithVenue, this.orderByProperty))

		this.currentPage = 1
	}

	private updateCheckbox() {
		if (this.searchFrom) {
			this.showPastEvents = false
			this.disableCheckbox = true
		} else {
			this.disableCheckbox = false
		}
	}

	private getFilteredList(allEvents: EventWithVenue[], searchTitle: string, searchVenue: string,
		searchFrom: string, searchTo: string): EventWithVenue[] {

		let filteredList = allEvents
		if (!searchFrom) {
			filteredList = this.filterPastEvents(filteredList)
		}
		if (searchTitle) {
			filteredList = this.filterListService.filterString(filteredList, 'title', searchTitle)
		}
		if (searchVenue) {
			filteredList = this.filterListService.filterString(filteredList, 'venueName', searchVenue)
		}
		if ((searchFrom) || (searchTo)) {
			filteredList = this.filterListService.filterMinMaxDate(filteredList, 'begin', 'begin', searchFrom, searchTo)
		}
		return filteredList
	}

	/**
	 * Default sollen vergangene Events nicht angezeigt werden. Wenn der User die Option inkl. abgelaufene Veranstaltungen (showPastEvents) auswaehlt
	 * sollen alle Veranstaltungen angezeigt werden.
	 * Wenn der User ein von Datum eingegeben hat, ueberschreibt dies die Option inkl. abgelaufene Veranstaltungen da alle Veranstaltungen ab dem
	 * ausgewaehlten Datum angezeigt werden sollen.
	 */
	private filterPastEvents(events: EventWithVenue[]) {
		let pastDate = this.determinePastEventsBeginDate()
		if (this.showPastEvents) {
			return events
		}
		return events.filter(event => {
			let match = false;
			if (moment(event.begin).isSameOrAfter(pastDate)) {
				match = true
			}
			return match
		})
	}

	private determinePastEventsBeginDate(): string {
		let fiveDaysAgo = moment().subtract(5, "days").startOf("day")
		return fiveDaysAgo.format(this.BACKEND_DATE_FORMAT)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-list/event-list.component.ts